export default "data:image/gif;base64,R0lGODlhFQAJAPABAKOjowAAACH5BAUKAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw=="